import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, GetUserSessionDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetSessionRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getSessionRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.users.getSession>>): Promise<GetUserSessionDto> {
    const accessToken = await getAccessToken();
    const [{ azureAdUserId }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/sessions/${azureAdUserId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getSessionRequest };
};

const useGetSession = (azureAdUserId: string | undefined, isAuthenticated: boolean) => {
  const { getSessionRequest } = useGetSessionRequest();

  return useQuery({
    queryKey: queryKeys.users.getSession(azureAdUserId),
    queryFn: getSessionRequest,
    enabled: azureAdUserId !== undefined && isAuthenticated,
  });
};

export { useGetSession };
